var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBankTransfer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.798 30.316a3.223 3.223 0 0 1-.041-.516V14.903H2.343a1.6 1.6 0 0 1-.994-2.854L15.53.812a1.6 1.6 0 0 1 2.024.03l13.345 11.237a1.6 1.6 0 0 1-1.03 2.824h-1.903V29.8c0 .176-.014.348-.041.516h1.389a1.342 1.342 0 0 1 0 2.684H2.409a1.342 1.342 0 0 1 0-2.684h1.389zM7.79 15.55v14.765h2.69V15.55H7.79zm6.725 0v14.765h2.69V15.55h-2.69zm6.725 0v14.765h2.69V15.55h-2.69z",
  fill: "#A58EE7",
  fillRule: "evenodd"
})));
export { SvgBankTransfer as ReactComponent };
export default __webpack_public_path__ + "assets/media/bank-transfer.bd58ca580f495fe8bf3e4f996acf544d.svg";